"use strict";
'use client';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetUnAuthWheel = void 0;
var next_intl_1 = require("next-intl");
var react_1 = require("react");
var currencies_1 = require("../currencies");
var keys_1 = require("../keys");
var useQuery_1 = require("../useQuery");
var useGetUnAuthWheel = function () {
    var currency = (0, currencies_1.useCurrentCurrency)();
    var lang = (0, next_intl_1.useLocale)();
    var _a = (0, useQuery_1.useQuery)({
        path: keys_1.GET_PUBLIC_WHEEL,
        payload: {
            currency: currency,
            lang: lang,
        },
    }), data = _a.data, error = _a.error, isLoading = _a.isLoading, isValidating = _a.isValidating;
    return (0, react_1.useMemo)(function () {
        var _a, _b, _c;
        return ({
            data: ((_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.wheel) === null || _b === void 0 ? void 0 : _b.promotions) === null || _c === void 0 ? void 0 : _c.map(function (promo) { return (__assign(__assign({}, promo), { ticketsAmount: promo === null || promo === void 0 ? void 0 : promo.startTicketsAmount })); })) || [],
            isLoading: isLoading,
            isValidating: isValidating,
            error: error,
        });
    }, [data, isLoading, isValidating, error]);
};
exports.useGetUnAuthWheel = useGetUnAuthWheel;
